import React, { useEffect, useState } from "react";
import CustomizeTime from "../Drawers/CustomizeTime";
import Filtericon from "../../assets/svg/filter-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import DateFilter from "../Dropdown/DateFilter";
import Sidebar from "../../Components/Sidebar/Sidebar";
import ConfirmationModal from "../Modals/ConfirmationModal";
import Dropdown from "../Dropdown/Dropdown";
import "./coupon.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { servicePost } from "../../helper/api";
import moment from "moment";
const DummyCoupan = [
  {
    copounCode: "RBCYFOS4637",
    startDate: "01 May, 2024",
    expiryDate: "10 May, 2024",
    type: "./images/icons/one-time-type.svg",
    amount: "125.00",
  },
  {
    copounCode: "RBCYFOS4637",
    startDate: "01 May, 2024",
    expiryDate: "10 May, 2024",
    type: "./images/icons/one-time-type.svg",
    amount: "125.00",
  },
];

// Cleaner DropDown Values
const TypeDropData = [
  {
    name: "All",
  },
  {
    name: "One Time",
  },
  {
    name: "Expiry",
  },
];

const Coupon = () => {
  const [modalShow, setModalShow] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [amount, setAmount] = useState("");

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const [listCoupon, setListCoupon] = useState();
  const navigate = useNavigate();
  //////////////////////////////////////
  const getAllCoupons = async () => {
    try {
      const getAllTx = await servicePost(
        "adminbooking/getCoupon",
        {},
        notification,
        authToken
      );

      const formatDate = (date) => {
        const d = new Date(date);
        return d.toISOString().split("T")[0];
      };

      // Filter coupons based on the provided filters
      const filteredCoupons = getAllTx.data.filter((coupon) => {
        const matchesStartDate = startDate
          ? formatDate(coupon.startDate) === formatDate(startDate)
          : true;
        const matchesEndDate = expiryDate
          ? formatDate(coupon.endDate) === formatDate(expiryDate)
          : true;
        const matchesType =
          selectedType && selectedType !== "All"
            ? coupon.couponType === selectedType
            : true; // If "All", reset the filter and show all types
        const matchesAmount = amount ? coupon.amount === amount : true;

        // Return true if all conditions match
        return (
          matchesStartDate && matchesEndDate && matchesType && matchesAmount
        );
      });

      setListCoupon(filteredCoupons.reverse());
    } catch (error) {}
  };

  useEffect(() => {
    getAllCoupons();
  }, [startDate, expiryDate, amount, selectedType]);

  ////////////////////
  const deleteCoupon = async (id) => {
    try {
      const deletedata = await servicePost(
        "adminbooking/deleteCoupon",
        {
          id: id,
        },
        notification,
        authToken
      );
      if (deletedata.message == "SUCCESS") {
        getAllCoupons();
      }
    } catch (error) {}
  };
  ///////////////////
  // handle Status Change

  const handleDateChange = (selectedDate) => {
    setSelectedDate(selectedDate);
  };

  const [filterDate, setFilterDate] = useState("");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");

  const goToPaymentDetail = (data) => {
    // navigate("/cleaner-payment-detail");
  };

  const handleDropdownChange = (field) => (value) => {
    if (field === "Type") {
      setSelectedType(value);
    }
  };

  const goToCreateCoupon = () => {
    navigate("/create-coupon");
  };
  const goToEditCoupon = (data) => {
    navigate("/edit-coupon", { state: { data } });
  };

  return (
    <>
      <ConfirmationModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        type="Are you sure to change the status of this transaction"
      />
      <Navbar />
      <div
        className="offcanvas offcanvas-end offcanvas-custom"
        tabIndex="-1"
        id="customizeDatecanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 id="offcanvasRightLabel">Customize time range</h5>

          <svg
            className="drawer-cross-icon"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            xmlns="http://www.w3.org/2000/svg"
            width="38.894"
            height="38.894"
            viewBox="0 0 38.894 38.894"
          >
            <path
              id="Path_18510"
              data-name="Path 18510"
              d="M38.894,18.763v1.367c-.03.2-.066.4-.087.595-.062.577-.087,1.16-.18,1.732a18.957,18.957,0,0,1-4.2,9.313,19.088,19.088,0,0,1-12.867,6.963c-.475.055-.95.107-1.425.161H18.763c-.589-.06-1.18-.1-1.766-.184A19.039,19.039,0,0,1,7.48,34.7,19.112,19.112,0,0,1,.16,21.555Q.08,20.881,0,20.207V18.687c.029-.173.064-.345.087-.518.115-.875.165-1.764.349-2.624A19.178,19.178,0,0,1,8.516,3.423,18.658,18.658,0,0,1,17.3.163C17.788.11,18.275.054,18.763,0h1.367c.173.028.346.065.52.083.6.062,1.212.082,1.808.181A19.116,19.116,0,0,1,32.821,5.4a19.035,19.035,0,0,1,5.913,11.935q.08.712.16,1.425m-21.765.7c-.32.306-.617.579-.9.863q-1.963,1.957-3.92,3.921A1.655,1.655,0,0,0,13.23,27.1a1.668,1.668,0,0,0,1.464-.56q2.226-2.232,4.457-4.458c.1-.1.2-.185.348-.327a3.961,3.961,0,0,0,.281.359q2.225,2.232,4.457,4.458a1.628,1.628,0,0,0,2.109.283,1.645,1.645,0,0,0,.231-2.615c-1.487-1.5-2.987-2.992-4.481-4.487-.1-.1-.186-.2-.321-.344.238-.221.465-.42.679-.633q2.057-2.051,4.108-4.109a1.655,1.655,0,1,0-2.334-2.34q-2.248,2.236-4.486,4.483c-.095.095-.2.184-.315.294-.892-.9-1.756-1.771-2.622-2.64-.724-.726-1.446-1.454-2.177-2.173a1.583,1.583,0,0,0-1.7-.431,1.6,1.6,0,0,0-1.131,1.352,1.651,1.651,0,0,0,.547,1.467c1.577,1.573,3.151,3.149,4.789,4.787"
              fill="#00A19B"
            />
          </svg>
        </div>
        <div className="offcanvas-body">
          <CustomizeTime
            setFilterStartDate={setFilterStartDate}
            setFilterEndDate={setFilterEndDate}
            filterStartDate={filterStartDate}
            filterEndDate={filterEndDate}
          />
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end offcanvas-custom"
        tabIndex="-1"
        id="filtercanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 id="offcanvasRightLabel">Filters</h5>

          <svg
            className="drawer-cross-icon"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            xmlns="http://www.w3.org/2000/svg"
            width="38.894"
            height="38.894"
            viewBox="0 0 38.894 38.894"
          >
            <path
              id="Path_18510"
              data-name="Path 18510"
              d="M38.894,18.763v1.367c-.03.2-.066.4-.087.595-.062.577-.087,1.16-.18,1.732a18.957,18.957,0,0,1-4.2,9.313,19.088,19.088,0,0,1-12.867,6.963c-.475.055-.95.107-1.425.161H18.763c-.589-.06-1.18-.1-1.766-.184A19.039,19.039,0,0,1,7.48,34.7,19.112,19.112,0,0,1,.16,21.555Q.08,20.881,0,20.207V18.687c.029-.173.064-.345.087-.518.115-.875.165-1.764.349-2.624A19.178,19.178,0,0,1,8.516,3.423,18.658,18.658,0,0,1,17.3.163C17.788.11,18.275.054,18.763,0h1.367c.173.028.346.065.52.083.6.062,1.212.082,1.808.181A19.116,19.116,0,0,1,32.821,5.4a19.035,19.035,0,0,1,5.913,11.935q.08.712.16,1.425m-21.765.7c-.32.306-.617.579-.9.863q-1.963,1.957-3.92,3.921A1.655,1.655,0,0,0,13.23,27.1a1.668,1.668,0,0,0,1.464-.56q2.226-2.232,4.457-4.458c.1-.1.2-.185.348-.327a3.961,3.961,0,0,0,.281.359q2.225,2.232,4.457,4.458a1.628,1.628,0,0,0,2.109.283,1.645,1.645,0,0,0,.231-2.615c-1.487-1.5-2.987-2.992-4.481-4.487-.1-.1-.186-.2-.321-.344.238-.221.465-.42.679-.633q2.057-2.051,4.108-4.109a1.655,1.655,0,1,0-2.334-2.34q-2.248,2.236-4.486,4.483c-.095.095-.2.184-.315.294-.892-.9-1.756-1.771-2.622-2.64-.724-.726-1.446-1.454-2.177-2.173a1.583,1.583,0,0,0-1.7-.431,1.6,1.6,0,0,0-1.131,1.352,1.651,1.651,0,0,0,.547,1.467c1.577,1.573,3.151,3.149,4.789,4.787"
              fill="#00A19B"
            />
          </svg>
        </div>
        <div className="offcanvas-body">
          <div className="mobile-filter-drawer-wrapper">
            <div className="mobile-filter-drawer-wrap filter-select-wraper">
              <div className="filter-date-input-wrap">
                <label> Start Date</label>
                <DatePicker
                  minDate={new Date()}
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  customInput={
                    <div className="custom-date-input1">
                      <img
                        src="./images/icons/date.svg"
                        alt="icon"
                        className="datepicker-icon"
                      />

                      <input
                        type="text"
                        placeholder="Select date"
                        value={
                          startDate
                            ? moment(startDate).format("DD MMM YYYY")
                            : ""
                        }
                      />
                    </div>
                  }
                />
              </div>

              <div className="filter-date-input-wrap">
                <label> Expiry Date </label>
                <DatePicker
                  minDate={new Date()}
                  selected={expiryDate}
                  onChange={(date) => setExpiryDate(date)}
                  customInput={
                    <div className="custom-date-input1">
                      <img
                        src="./images/icons/date.svg"
                        alt="icon"
                        className="datepicker-icon"
                      />

                      <input
                        type="text"
                        placeholder="Select Date"
                        value={
                          expiryDate
                            ? moment(expiryDate).format("DD MMM YYYY")
                            : ""
                        }
                      />
                    </div>
                  }
                />
              </div>

              <div className="filter-date-input-wrap">
                <label> Amount </label>
                <input
                  type="number"
                  placeholder="XXXXXXXX"
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>

              <Dropdown
                onTypeChange={handleDropdownChange("Type")}
                label="Type"
                data={TypeDropData}
              />
            </div>
          </div>
        </div>
      </div>
      <Sidebar />
      <div className="trasfer-histroy-wrapper transfer-admin-history-wrap">
        <div className="container">
          <div className="transfer-history-header coupon-header-main-wrap">
            <div className="coupon-left-header-wrap">
              <img
                className="cleaner-payment-icon"
                src="./images/icons/coupon.svg"
                alt="icon"
              />
              <h3> Coupon </h3>
            </div>
            <div className="coupon-right-wrap">
              <button onClick={goToCreateCoupon}> Create Coupon</button>
            </div>
          </div>

          <div className="fiter-dropdown">
            <div className="filter-select-wraper">
              <div className="filter-date-input-wrap">
                <label> Start Date</label>
                <DatePicker
                  minDate={new Date()}
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  customInput={
                    <div className="custom-date-input1">
                      <img
                        src="./images/icons/date.svg"
                        alt="icon"
                        className="datepicker-icon"
                      />

                      <input
                        type="text"
                        placeholder="Select date"
                        value={
                          startDate
                            ? moment(startDate).format("DD MMM YYYY")
                            : ""
                        }
                      />
                    </div>
                  }
                />
              </div>

              <div className="filter-date-input-wrap">
                <label> Expiry Date </label>
                <DatePicker
                  minDate={new Date()}
                  selected={expiryDate}
                  onChange={(date) => setExpiryDate(date)}
                  customInput={
                    <div className="custom-date-input1">
                      <img
                        src="./images/icons/date.svg"
                        alt="icon"
                        className="datepicker-icon"
                      />

                      <input
                        type="text"
                        placeholder="Select Date"
                        value={
                          expiryDate
                            ? moment(expiryDate).format("DD MMM YYYY")
                            : ""
                        }
                      />
                    </div>
                  }
                />
              </div>

              <div className="filter-date-input-wrap">
                <label> Amount </label>
                <input
                  type="number"
                  placeholder="XXXXXXXX"
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>

              <Dropdown
                onTypeChange={handleDropdownChange("Type")}
                label="Type"
                data={TypeDropData}
              />
            </div>
          </div>

          <div className="fiter-dropdown-mobile">
            <div
              className="mobile-filter-wrap"
              data-bs-toggle="offcanvas"
              data-bs-target="#filtercanvasRight"
              aria-controls="filtercanvasRight"
            >
              <h3> Filters</h3>
              <div>
                <img src={Filtericon} alt="icon" />
              </div>
            </div>
          </div>

          <div className="tranfer-history-dropdown-wrapper table-responsive">
            <span
              id="customizedate"
              data-bs-toggle="offcanvas"
              data-bs-target="#customizeDatecanvasRight"
              aria-controls="customizeDatecanvasRight"
            ></span>

            <table id="transfer" className="table table-striped">
              <thead>
                <tr>
                  <th> Coupon Code </th>
                  <th> Start Date </th>
                  <th> Expiry Date </th>
                  <th> Type </th>
                  <th> Amount </th>
                  <th> View</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {listCoupon?.length > 0 ? (
                  listCoupon.map((data, index) => (
                    <tr key={index}>
                      <td>{data.couponCode}</td>
                      <td>
                        {data.startDate
                          ? moment(data.startDate).format("DD MMM YYYY")
                          : "--"}
                      </td>
                      <td>
                        {data.startDate
                          ? moment(data.endDate).format("DD MMM YYYY")
                          : "--"}
                      </td>
                      <td>
                        {data.couponType}
                        {/* <img src={data.type} alt="icon" /> */}
                      </td>
                      <td> ${data.amount}</td>
                      <td>
                        <img
                          className="table-view-icon"
                          style={{ cursor: "pointer" }}
                          src="./images/icons/view-icon.svg"
                          alt="icon"
                          onClick={() => {
                            goToEditCoupon(data);
                          }}
                        />
                      </td>
                      <td>
                        <img
                          style={{ cursor: "pointer" }}
                          src="./images/icons/delete1.svg"
                          alt="icon"
                          onClick={() => {
                            deleteCoupon(data.id);
                          }}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Coupon;
